import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 add_employee_to_tenant: { message: "idle" },
};

export const add_employee_to_tenant_Slice = createSlice({
 name: "add_employee_to_tenant",
 initialState,
 reducers: {
  success_add_employee_to_tenant: (state, action) => {
   state.add_employee_to_tenant = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_add_employee_to_tenant: (state, action) => {
   state.add_employee_to_tenant = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_employee_to_tenant: (state) => {
   state.add_employee_to_tenant = { status: app_consts.IDLE };
  },
  loading_add_employee_to_tenant: (state) => {
   state.add_employee_to_tenant = { status: app_consts.LOADING };
  },
 }
});

export const { success_add_employee_to_tenant, fail_add_employee_to_tenant, reset_add_employee_to_tenant, loading_add_employee_to_tenant } = add_employee_to_tenant_Slice.actions;

export default add_employee_to_tenant_Slice.reducer;